import React from "react"

export default function Authors(
  props: { 
    embedCode: string 
  }
) {
  const { embedCode } = props;


  const style = {
    boxSizing: 'border-box',
    borderWidth: 'initial',
    borderStyle: 'none',
  };

  return (
    <div className="libsyn-embed-container">
      <iframe 
        // allowfullscreen="" 
        // frameborder="0" 
        height="90" 
        // mozallowfullscreen="" 
        // msallowfullscreen="" 
        // oallowfullscreen="" 
        scrolling="no" 
        src={embedCode} 
        // style={style}
        // webkitallowfullscreen="" 
        width="100%"
      ></iframe>
  </div>
  );
}
